import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';

@Component({
  selector: 'io-topbar',
  standalone: true,
  imports: [ToolbarModule],
  templateUrl: './io-topbar.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IoTopbarComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() icon = 'pi pi-th-large';
  @Input() styleClass = '';
  @Input() showDivider = true;

  get computedClass(): string {
    return [
      'rounded-xl border-0 bg-surface-0 px-4 py-[0.9rem] max-md:p-3',
      '[&_.p-toolbar-start]:max-md:w-full [&_.p-toolbar-end]:max-md:mt-[0.6rem] [&_.p-toolbar-end]:max-md:w-full',
      this.showDivider ? 'border border-surface-300' : '',
      this.styleClass,
    ]
      .filter(Boolean)
      .join(' ');
  }
}
